import {
  getExternalLocalizedLink,
  getLocalizedHelpCenterLink,
} from "../helpers/routingHelpers";

const externalLinks = {
  profileActivation: getExternalLocalizedLink("/profile/activation"),
  browsePopular: getExternalLocalizedLink("/videos/popular"),
  browseSimulcasts: getExternalLocalizedLink("/simulcasts"),
  watchlist: getExternalLocalizedLink("/watchlist"),
  history: getExternalLocalizedLink("/history"),
  crunchylists: getExternalLocalizedLink("/crunchylists"),
  myAccount: getExternalLocalizedLink("/account/preferences"),
  manga: getExternalLocalizedLink("/comics/manga"),
  releaseCalendar: getExternalLocalizedLink("/simulcastcalendar"),
  logout: getExternalLocalizedLink("/logout"),
  welcome: getExternalLocalizedLink("/welcome"),
  premium: getExternalLocalizedLink("/premium"),
  redeem: getExternalLocalizedLink("/redeem"),
  tos: getExternalLocalizedLink("/tos"),
  about: getExternalLocalizedLink("/about/index.html"),
  privacy: "https://www.crunchyroll.com/privacy/index.html",
  helpCenter: getLocalizedHelpCenterLink(),
  games: "https://www.crunchyroll.com/games/index.html",
  store: "https://store.crunchyroll.com/",
  jobs: "https://www.crunchyroll.com/about/jobs/index.html",
  genderEqualityIndex:
    "https://www.crunchyroll.com/gender-equality-index/index.html",
  modernSlaveryTransparencyStatement:
    "https://www.sony.com/en/SonyInfo/csr/library/msa/sis4ug000000k11n-att/MSA_2022.pdf",
  doNotSellMyPersonalInformation:
    "https://privacyportal-cdn.onetrust.com/dsarwebform/d19e506f-1a64-463d-94e4-914dd635817d/b9eb997c-9ede-451b-8fd4-29891782a928.html",
  adChoices: "https://www.sonypictures.com/corp/privacy.html#section11B",
};

export default externalLinks;
